import * as runtime from "@baseline/runtime";
import React, { FC } from "react";
import ReactDOM from "react-dom/client";
import * as baselineReact from "../react";


export class UIManager
{
    constructor(
        readonly context: runtime.Context,
        options?: Options
    )
    {
        this.useContainer(options?.container ?? document);
        this.useComponent(options?.component ?? UIManager.defaultComponent);
    }

    useContainer(container: Element | Document): this
    {
        this.container = container;
        return this;
    }

    useComponent(component: FC): this
    {
        this.component = component;
        return this;
    }

    start(): void
    {
        this.render();
    }

    container: Element | Document;
    component: FC;


    protected render(): void
    {
        // Unmount existing root
        if (this.root)
        {
            this.root.unmount();
            delete this.root;
        }

        // Create context bound component
        const component = baselineReact.Context.bind(this.component, this.context);

        // Clear container
        Array.from(this.container.childNodes)
            .forEach(child => this.container.removeChild(child));

        // Crente root, render in container
        const element = React.createElement(component);
        this.root = ReactDOM.createRoot(this.container);
        this.root.render(element);
    }

    protected root: ReactDOM.Root;
}


export namespace UIManager
{
    export const defaultComponent = () => React.createElement(React.Fragment);
}


export interface Options
{
    container?: Element | Document;
    component?: FC;
}
